import type { ParsedUrlQuery } from 'querystring'

import { NextRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'

export function slurEmail(email: string): string {
  const [localPart, domainPart] = email.split('@')

  if (localPart.length <= 4) {
    return `${'*'.repeat(localPart.length)}@${domainPart}`
  }

  if (localPart.length === 5) {
    const firstChar = localPart[0]
    const lastChar = localPart[localPart.length - 1]
    return `${firstChar}${'*'.repeat(3)}${lastChar}@${domainPart}`
  }

  const [firstChar, secondChar] = [localPart[0], localPart[1]]
  const [secondToLastChar, lastChar] = [localPart[localPart.length - 2], localPart[localPart.length - 1]]
  return `${firstChar}${secondChar}${'*'.repeat(2)}${secondToLastChar}${lastChar}@${domainPart}`
}

export function getRouterQueryFrom(router: NextRouter): string | undefined {
  let from = router?.query?.from || router.query?.state
  if (router.pathname.includes('/treasure-trail')) {
    from = ROUTES.TREASURETRAIL
  } else if (router.pathname.includes('/windsurfer')) {
    from = ROUTES.WINDSURFER
  } else if (router.pathname.includes('/junior-math')) {
    from = ROUTES.MATH_VAULT
  } else if (router.pathname.includes('/multgame')) {
    from = ROUTES.MULT_GAME
  } else if (router.pathname.includes('/stacknload')) {
    from = ROUTES.STACKNLOAD
  } else if (router.pathname.includes('/campaigns')) {
    from = router.pathname
  }
  return from ? (from as string) : undefined
}

export function getLoginPathFromSSOState(router: NextRouter): {
  pathname: string
  query?: ParsedUrlQuery
} {
  const state = router.query.state as string
  if (state?.includes('/games/')) {
    return { pathname: state }
  } else if (state?.includes('/subscription/')) {
    const priceId = state.split('?')?.[1]

    let query = {}

    if (priceId.includes('price_id')) {
      const params = new URLSearchParams(priceId)
      query = { price_id: params.get('price_id') }
    }

    return { pathname: ROUTES.SUBSCRIPTION_CHECKOUT_LOGIN, query }
  }

  return { pathname: ROUTES.LOGIN, query: state ? { state } : {} }
}
export const queryIsValid = (
  query: ParsedUrlQuery,
): query is {
  state: string
  code: string
} => {
  return Boolean(query.code)
}
